
import {fixPageAfterDel} from '@/utils/utils'
import { EditModal, BindModal, ImportModal} from './components'

import columns from './tableConfig'
import {searchItems} from './searchFormConfig'

let searchCache = {}
import store from '@/store'
import {
  BindTerminal,
  QueryTerminalIndex,
  TerminalCreate,
  TerminalDelete,
  TerminalImport,
  TerminalUpdate,
  UnbindTerminal
} from '@/apis/device'

const enumsData = store.state.enumsStore.enumsData

const { DeviceType : deviceTypes } = enumsData
console.log(deviceTypes)
export default {
  name: 'Device.Index',
  components: {EditModal, BindModal, ImportModal},
  data() {
    return {
      searchItems,
      searching: false,
      confirmGroupLoading: false,
      deviceTypes,
      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },


      showAppInfoModal: false,
      showEditModal: false,
      showBindModal: false,
      showImportModal: false,

      target: null,
      deviceStates : [
        {code: 0, name: '正常'},
        {code: 1, name: '禁用'},
        {code: 2, name: '删除'},
      ],
      templateList:[],
    }
  },
  watch: {
    '$route.params.search': async function(search) {
      if (search) {
        this.$refs.searchForm.handlerSearch()
      }
    }
  },
  created() {
    this.$nextTick(async () => {
      const { search } = this.$route.params
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    // 查询模板
    async getDeviceIndex(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        const {industryId,keyword} = searchData
        const {collection: data, pageInfo} = await QueryTerminalIndex({
          industryId,
          keyword,
          page,
          perPage: this.pagination.pageSize
        })
        this.data = data
        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) {
        console.log(error)
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const {current, pageSize} = pagination
      this.pagination.pageSize = pageSize
      this.getDeviceIndex(current)
    },
    queryTypeName(code){
      console.log(deviceTypes)
      return deviceTypes.find(item=>item.code === code).name
    },

    // 提交编辑设备的信息
    async handleSubmitEdit(value) {
      let data = Object.assign({},value)
      try {
        const {id} = data
        if (!id) {
          await TerminalCreate(data)
          await this.getDeviceIndex()
        } else {
          await TerminalUpdate(data)
          await this.getDeviceIndex(this.pagination.current)
        }
      } catch (error) {
      }
      this.handlerCloseEditModal()
    },
    // 提交编辑设备的信息
    async handleBindSubmit(value) {
      let data = Object.assign({},value)
      try {
        const {deviceId, storeId} = data
        await BindTerminal({ deviceId, storeId })
        await this.getDeviceIndex(this.pagination.current)
      } catch (error) {
      }
      this.handlerCloseBindModal()
    },
    // 提交编辑设备的信息
    async handleImportSubmit(value) {
      let list = Object.assign({},value)
      const {data} = list
      try {
        await TerminalImport({devices : data})
        await this.getDeviceIndex(this.pagination.current)
      } catch (error) {
      }
      this.handlerCloseImportModal()
    },
    // 打开编辑设备模态框
    handlerOpenEditModal(data) {
      let info = null
      if (data){
        info = Object.assign({},data)
      }
      this.target = info
      this.showEditModal = true
    },

    // 关闭编辑设备模态框
    handlerCloseEditModal() {
      this.target = null
      this.showEditModal = false
    },
    // 打开绑定设备模态框
    handlerOpenBindModal(data) {
      let info = null
      if (data){
        info = Object.assign({},data)
      }
      this.target = info
      this.showBindModal = true
    },
    // 关闭编辑设备模态框
    handlerCloseBindModal() {
      this.target = null
      this.showBindModal = false
    },
    // 打开绑定设备模态框
    handlerOpenImportModal(data) {
      this.showImportModal = true
    },
    // 关闭编辑设备模态框
    handlerCloseImportModal() {
      this.target = null
      this.showImportModal = false
    },
    // 删除设备
    handlerDeleteTerminal(data) {
      const {id, sn} = data
      this.$confirm({
        title: '即将删除设备，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `SN：${sn || '-'}`)
        ]),
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return TerminalDelete(id ).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getDeviceIndex(this.pagination.current)
          })
        }
      })
    },
    // 删除设备
    handlerUnbindStore(data) {
      const {id, sn} = data
      this.$confirm({
        title: '即将解绑店铺设备，信息如下：',
        content: h => h('div', {style: {fontSize: '12px'}}, [
          h('p', {style: {margin: '5px 0 0'}}, `SN：${sn || '-'}`)
        ]),
        okText: '解绑',
        okType: 'danger',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return UnbindTerminal(id ).then(() => {
            this.pagination = fixPageAfterDel(this.pagination)
            this.getDeviceIndex(this.pagination.current)
          })
        }
      })
    },
  }
}
